import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { useTranslation } from 'react-i18next';
import { MembersDataTable } from '@/routes/console/_authenticated/_layout/workspace/_layout/-features/members-data-table';
import { OverviewCard } from '@/routes/console/_authenticated/_layout/workspace/_layout/-features/overview-card';
import { DetailCard } from '@/routes/console/_authenticated/_layout/workspace/_layout/-features/detail-card';
import { BrandingCard } from '@/routes/console/_authenticated/_layout/workspace/_layout/-features/branding-card';
import { WorkspaceInvitesAdminTable } from '@/routes/console/_authenticated/_layout/workspace/_layout/-features/workspace-invites-admin-table';
import { isFree } from '@/lib/role';
export const Route = createFileRoute('/console/_authenticated/_layout/workspace/_layout/')({
    component: WorkspaceSettingsPage,
});
function WorkspaceSettingsPage() {
    const { t } = useTranslation();
    const { workspace, user } = useAuthenticationState();
    if (!workspace || !user) {
        return (<div className="flex h-full items-center justify-center">
                <p className="text-sm text-muted-foreground">{t('workspaces.not_found', { ns: 'glossary' })}</p>
            </div>);
    }
    return (<div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <div className="flex flex-col space-y-2 w-full">
                {/* Overview */}
                <OverviewCard workspace={workspace}/>

                {/* Details */}
                <DetailCard workspace={workspace}/>

                {/* Branding (Solo+ watermark toggle; Free sees upgrade hint) */}
                <BrandingCard workspace={workspace}/>
            </div>

            {/* Members */}
            <div className="flex flex-col space-y-2 w-full">
                <MembersDataTable workspace={workspace} user={user}/>

                {!isFree(workspace) && <WorkspaceInvitesAdminTable workspace={workspace}/>}
            </div>
        </div>);
}
